import { useContext, useEffect, useRef, useState } from 'react';

import styles from './WaitingForJoiningScreen.module.css';

import { GlobalContext } from "../../contexts/globalContext";

import New_InputTextComponent from '../keyboard/New_InputTextComponent';
import New_DropDownComponent from '../keyboard/New_DropDownComponent';

import CountriesJson from '../../../src/graphics/country.json';
import arrowLeft from '../../graphics/arrow-left-animation.json';

import Lottie from 'react-lottie-player';

import * as tf from '@tensorflow/tfjs';
import * as blazeface from '@tensorflow-models/blazeface';

const RegisterNewVisitor = () => {
    const {
        localSocketRef, keyboardRef, setWaitingForJoining, socketRef, conferenceLogin, currentConference, deskData, setCurrentParticipant, setCurrentConference, setConferencePaused
    } = useContext(GlobalContext);

    const inputVisitorNameRef = useRef();
    const inputRefCountry = useRef();
    const inputEntitleNameRef = useRef();
    const videoRef = useRef();
    const detectionIntervalRef = useRef(null);
    const outsideDivRef = useRef(null);
    const insideDivRef = useRef(null);
    const componentRef = useRef(null);

    const [localStream, setLocalStream] = useState(null);
    const [isNameCompleted, setIsNameCompleted] = useState(false);
    const [faceModel, setFaceModel] = useState(null);
    const [videoReady, setVideoReady] = useState(false);

    const handleNameChange = () => {
        setIsNameCompleted(inputVisitorNameRef.current.value?.trim().length > 0);
    };

    useEffect(() => {
        navigator.mediaDevices.getUserMedia({
            video: {
                width: {
                    min: 640,
                    max: 960,
                },
                height: {
                    min: 400,
                    max: 540,
                }
            }, audio: false
        })
            .then(stream => {
                setLocalStream(stream);
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                }
                videoRef.current.onloadedmetadata = () => {
                    videoRef.current.play();
                    setVideoReady(true);
                };
            })
            .catch(error => {
                console.error("Error accessing primary media devices.", error);
            });

        const loadModel = async () => {
            const model = await blazeface.load();
            setFaceModel(model);
        };

        loadModel();

        const playVideosListener = async function (conferenceId) {
            if (conferenceId === currentConference._id) {
                if (localSocketRef.current?.connected) {
                    localSocketRef.current.emit("serial:cameraUp");
                }
            }
        };

        const pauseVideosListener = async function (conferenceId) {
            if (conferenceId === currentConference._id) {
                if (localSocketRef.current?.connected) {
                    localSocketRef.current.emit("serial:cameraDown");
                }
            }
        };

        socketRef.current.on('PLAY_VIDEOS', playVideosListener);
        socketRef.current.on('PAUSE_VIDEOS', pauseVideosListener);

        return () => {
            socketRef.current?.off('PLAY_VIDEOS', playVideosListener);
            socketRef.current?.off('PAUSE_VIDEOS', pauseVideosListener);

            if (localStream) {
                localStream.getTracks().forEach(track => track.stop());
            }
            if (detectionIntervalRef.current) {
                clearTimeout(detectionIntervalRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (videoReady && faceModel) {
            startFaceDetection();
        } else {
            componentRef.current.style.height = '918px';
            videoRef.current.style.height = '1px';
            outsideDivRef.current.style.height = '0px';
            insideDivRef.current.style.height = '0px';
        }
    }, [videoReady, faceModel]);

    const showVideoForRegisterNewUserRef = useRef(0);

    const startFaceDetection = () => {
        const detect = async () => {
            if (!faceModel || !videoRef.current) return;

            const predictions = await faceModel.estimateFaces(videoRef.current, false);

            if (predictions.length > 0) {
                if (showVideoForRegisterNewUserRef.current > 0) {
                    showVideoForRegisterNewUserRef.current++;
                } else {
                    showVideoForRegisterNewUserRef.current = 1;
                }

                if (showVideoForRegisterNewUserRef.current === 10) {
                    videoRef.current.style.height = '1100px';
                    outsideDivRef.current.style.height = '618px';
                    insideDivRef.current.style.height = '618px';
                    componentRef.current.style.height = '1840px';
                }
            } else {
                if (showVideoForRegisterNewUserRef.current < 0) {
                    showVideoForRegisterNewUserRef.current--;
                } else {
                    showVideoForRegisterNewUserRef.current = -1;
                }

                if (showVideoForRegisterNewUserRef.current === -10) {
                    componentRef.current.style.height = '918px';
                    videoRef.current.style.height = '1px';
                    outsideDivRef.current.style.height = '0px';
                    insideDivRef.current.style.height = '0px';
                }
            }

            detectionIntervalRef.current = setTimeout(detect, 100);
        };

        detect();
    };

    const RegisterNewVisitor = () => {
        var body = {
            conferenceId: currentConference._id,
            name: inputVisitorNameRef.current.value,
            entitle: inputEntitleNameRef.current.value ? inputEntitleNameRef.current.value : null,
            deskId: deskData._id,
            country: inputRefCountry.current.currentChoice.value
        };

        socketRef.current.emit("CONFERENCE_ATTACH_NEW_VISITOR_TO_DESK", body, (data) => {
            if (!data.error && data.conference) {
                setWaitingForJoining(true);
                setCurrentParticipant(data.participant);
                setCurrentConference(data.conference);
                setConferencePaused(data.conference.paused);
            }
        });
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row', height: '100%', width: '100%', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
            <div ref={componentRef} className={styles.component} style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                alignSelf: 'center',
                position: 'relative',
                marginTop: -100
            }}>
                <div ref={outsideDivRef} style={{ marginTop: 35, display: 'flex', gap: '20px', width: '1100px', height: '618px', flexWrap: 'wrap', justifyContent: 'center', transition: "height 1s" }}>
                    <div ref={insideDivRef} style={{ height: 618, overflow: "hidden", borderRadius: 20, transition: "height 1s" }}>
                        <video
                            ref={videoRef}
                            autoPlay
                            muted
                            style={{ width: '100%', height: '1100px', marginTop: -200, transition: "height 1s" }}
                        ></video>
                    </div>
                </div>
                <div style={{ flex: 1, height: 100, width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    {/* <label className={styles.welcomeText} style={{ marginTop: 122 }}>Welcome!</label> */}
                    <label className={styles.nameAndEntitleText}>Name and entitling</label>
                    <New_InputTextComponent
                        ref={inputVisitorNameRef}
                        keyboardRef={keyboardRef}
                        value={conferenceLogin ? conferenceLogin.name : ""}
                        fontSize="40px"
                        placeHolder="Name"
                        styleType='POPUP'
                        width="1000px"
                        height="80px"
                        marginBottom="20px"
                        onChange={() => handleNameChange()}
                    />
                    <New_InputTextComponent
                        ref={inputEntitleNameRef}
                        keyboardRef={keyboardRef}
                        value={conferenceLogin ? conferenceLogin.entitle : ""}
                        fontSize="40px"
                        placeHolder="Position / Role"
                        styleType='POPUP'
                        width="1000px"
                        height="80px"
                        marginBottom="20px"
                    />
                    <New_DropDownComponent options={CountriesJson} ref={inputRefCountry} keyboardRef={keyboardRef} value="" placeHolder="Choose country" iconPosition="right" withDelete={true}
                        styleType='POPUP' width="1000px" height="80px" fontSize="40px" />

                    <div className={styles.confModeratorTextDiv} style={{ marginTop: 155 }}>
                        <label className={styles.confModeratorText}>STARTING SOON</label>
                    </div>
                    <label className={styles.customTextVisitor} style={{ marginTop: 20, }}> Press the button to confirm </label>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <button
                            className={styles.joinButton}
                            disabled={!isNameCompleted}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                alignContent: 'center',
                                justifyContent: 'space-evenly',
                                alignItems: 'center',
                                opacity: isNameCompleted ? 1 : 0.5,
                                cursor: isNameCompleted ? 'pointer' : 'not-allowed',
                                border: "none"
                            }}
                            onClick={RegisterNewVisitor}>
                            <Lottie
                                loop={true}
                                play={true}
                                animationData={arrowLeft}
                                style={{ position: "relative", width: 60, height: 35 }}
                            />
                            <label>Request to join</label>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RegisterNewVisitor;
